import React from 'react';
import { Check, Sparkles } from 'lucide-react';
import { InvitationTemplate } from '../../../types/invitation';
import { Customization } from '../types';
import { invitationTemplates } from '../data';

interface Step2Props {
  selectedTemplate: number | null;
  setSelectedTemplate: (id: number) => void;
  setCustomization: React.Dispatch<React.SetStateAction<Customization>>;
}

export const Step2_TemplateSelection: React.FC<Step2Props> = ({
  selectedTemplate,
  setSelectedTemplate,
  setCustomization,
}) => {
  const handleSelect = (template: InvitationTemplate) => {
    setSelectedTemplate(template.id);
    setCustomization(prev => ({
      ...prev,
      primaryColor: template.primaryColor
    }));
  };

  return (
    <div>
      <h3 className="text-xl font-semibold mb-6 flex items-center">
        <Sparkles className="h-6 w-6 text-pink-500 mr-3" />
        選擇邀請函範本
      </h3>
      <p className="text-gray-600 mb-6">精選 6 款專業設計範本，每一款都經過用戶喜愛度測試</p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {invitationTemplates.map((template) => (
          <div
            key={template.id}
            onClick={() => handleSelect(template)}
            className={`border-2 rounded-lg p-4 cursor-pointer transition-all hover:shadow-md ${
              selectedTemplate === template.id
                ? 'border-pink-500 bg-pink-50'
                : 'border-gray-200 hover:border-pink-300'
            }`}
          >
            <div className="aspect-[3/4] rounded-lg overflow-hidden mb-3 bg-gray-100">
              <img
                src={template.preview}
                alt={template.name}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <h4 className="font-medium text-gray-900 mb-1">{template.name}</h4>
            <p className="text-sm text-gray-600 mb-3">{template.description}</p>
            <div className="flex items-center space-x-2">
              <div
                className="w-4 h-4 rounded-full border border-gray-300"
                style={{ backgroundColor: template.primaryColor }}
              />
              <div
                className="w-4 h-4 rounded-full border border-gray-300"
                style={{ backgroundColor: template.secondaryColor }}
              />
              <span className="text-xs text-gray-500 ml-2 capitalize">{template.style}</span>
            </div>
            {selectedTemplate === template.id && (
              <div className="mt-2 flex items-center text-pink-600">
                <Check className="h-4 w-4 mr-1" />
                <span className="text-sm font-medium">已選擇</span>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
